module.exports = __webpack_public_path__ + "img/UserRetMetric.9c31f58b.png";